import styles from './Info.module.css';
import React from "react";

const eltern = [
    {
        name: "N. Rählert",
        class: "Schulelternbeirat",
        email: "schulelternbeirat@iks-schule.de",
        image: require("../../../ueberuns/unserteam/assets/f1d90f_8bbbb3749407488d92559e7c57c74b51~mv2.jpeg"),
    },
    {
        name: "C. Grigroean",
        class: "stellv. Schulelternbeirat",
        email: "schulelternbeirat@iks-schule.de",
        image: require("../../../ueberuns/unserteam/assets/f1d90f_8bbbb3749407488d92559e7c57c74b51~mv2.jpeg"),
    },

];
const ElternCard = ({ eltern }) => (

    <div className={styles.card}>
        <img src={eltern.image} alt={eltern.name} className={styles.image} />
        <div className={styles.class}>{eltern.class}</div>
        <div className={styles.name}>{eltern.name}</div>
        <div className={styles.email}>
            <a href={`mailto:${eltern.email}`}>{eltern.email}</a>
        </div>
    </div>
);
const Info = () => {

    return(
       <main className="wrapper wrapperContent">
           <section className={styles.section}>
             <div className={styles.text}>
                 <h1>SCHULELTERNBEIRAT</h1>
                 <h2>Welche Funktion hat der Schulelternbeirat?</h2>
                 <p>Der Schulelternbeirat ist ein Gremium aus gewählten zwei Eltern, das die Interessen der Eltern gegenüber der Schulleitung und anderen Gremien vertritt. Er fördert die Zusammenarbeit zwischen Eltern, Schule und Lehrerschaft, unterstützt die Schulentwicklung und ist ein wichtiger Ansprechpartner für Eltern bei Fragen oder Problemen rund um schulischen Leben. Der Schulelternbeirat hat das Recht, bei schulischen Entscheidungen, die die Schülerinnen und Schüler betreffen, mitzubestimmen und Ideen zur Verbesserung von Bildung und Erziehung einzubringen. Er ist ein bedeutendes Gremium für die Mitbestimmung und Mitgestaltung von schulischen Angelegenheiten durch Eltern.</p>
                 <div className={styles.container}>
                     {eltern.map((eltern, index) => (
                         <ElternCard key={index} eltern={eltern} />
                     ))}
                 </div>
             </div>
           </section>
           <section className={styles.section}>
              <div className={styles.list}>
                  <h1>ELTERNSPRECHSTUNDE</h1>
                  <h2>Kurze Info:</h2>
                  <ul>
                      <li>Erster Ansprechpartner ist für Sie die Klassenlehrerin oder der Klassenlehrer.</li>
                      <li>Wenden Sie sich bitte mit allen Fragen und Problemen zuerst an diese. Für Einzelberatungen können Sie jederzeit einen Termin vereinbaren. Die Pausen sind für Elterngespräche nicht geeignet.</li>
                      <li>Zweimal im Jahr findet ein Elternsprechtag statt. Bitte entnehmen Sie diese Termine aus unserem Schulkalender.</li>
                  </ul>
              </div>
           </section>

           <section className={styles.section}>
              <div className={styles.text} >
                  <h1>KRANKMELDUNG UND BEURLAUBUNG</h1>
                  <h2>Krankmeldung</h2>
                  <p>Bei Krankheitsfällen kontaktieren Sie bitte schriftlich das Sekretariat und die Klassenleitung.</p>

              </div>
              <div className={styles.text}>
                  <h2>Beurlaubung</h2>
                  <p>Beurlaubungen für einen Tag kann die Klassenlehrerin oder der Klassenlehrer aussprechen.</p>
                  <p>Beurlaubungen von mehreren Tagen können auf Antrag und nur in Ausnahmefällen von der Schulleitung genehmigt werden. Anträge auf Sonderurlaub vor und nach den Ferien reichen Sie bitte 3 Wochen vorher ein.</p>

              </div>
               <div className={styles.text}>
                   <h2>Hinweise zur Meldepflicht von Infektionskrankheiten</h2>
                   <p>Erläuterungen zum Infektionsschutzgesetz (§ 34 IfSG)</p>
                   <p>Bitte beachten Sie folgenden Hinweis: <br/>
                       Das Infektionsschutsgesetz sieht vor, dass Sie als Eltern oder Sorgeberechtigte dazu verpflichtet sind, der Gemeinschaftseinrichtung jede möglicherweise ansteckende Erkrankung möglichst frühzeitig zu melden.
                   </p>
               </div>

               <div className={styles.text}>
                   <h2>Kopflausbefall</h2>
                   <p>Damit der “Läuseplage” möglichst schnell Einhalt geboten werden kann, informieren die Eltern betroffener Kinder umgehend die Klassenlehrerin / den Klassenlehre</p>
                   <p>Wichtige Informationen hierzu finden Sie beim Gesundheitsamt Frankfurt:<br/>
                       <a href="https://frankfurt.de/-/media/frankfurtde/service-und-rathaus/verwaltung/aemter-und-institutionen/gesundheitsamt/pdf/infos-zu-kopflaeusen.ashx">Informationen zu Kopfläusen - FRANKFURT.DE</a>
                   </p>

                   <p>Links zu Behandlung und Formularen (Elternbriefe und Bestätigungen) in verschiedenen Sprachen finden Sie <br/>
                       hier: <a href="/assets/igsgrundstufe/Informationen Lausbefall.pdf" download>Informationen Lausbefall</a>
                   </p>

                   <p>FORMULAR ZUR BEHANDLUNGSBESTÄTIGUNG<br/>
                       Bitte legen Sie eine Behandlungsbestätigung vor, wenn das Kind wieder in die Schule kommt.<br/>
                   </p>
               </div>
           </section>

           <section className={styles.section}>
              <div className={styles.text}>
                  <h1>UNTERRICHTSZEITEN</h1>
                  <p>An- und Abmeldungen bitte schriftlich mitteilen</p>
                  <div className={styles.container}>
              </div>

               <table className={styles.table}>
                   <tr style={{background:"#c9e3ef"}}>
                       <th>Frühbetreuung</th>
                       <td>7:30 - 8:15 Uhr</td>
                   </tr>
                   <tr style={{background:"#c9e3ef"}}>
                       <th>1. Stunde</th>
                       <td>8:15 - 9:00 Uhr</td>
                   </tr>
                   <tr style={{background:"#c9e3ef"}}>
                       <th>2. Stunde</th>
                       <td>9:00 - 9:45 Uhr</td>
                   </tr>
                   <tr>
                       <td colSpan="2" style={{
                           background: "rgba(128,208,119,0.75)",
                           textAlign: "center",
                           verticalAlign: "top",
                           padding: "20px 0"
                       }}>
                           30 Min Pause</td>
                   </tr>
                   <tr style={{background:"#c9e3ef"}}>
                       <th>3. Stunde</th>
                       <td>10:15 - 11:00 Uhr</td>
                   </tr>
                   <tr style={{background:"#c9e3ef"}}>
                       <th>4. Stunde</th>
                       <td>11:00 - 11:45 Uhr</td>
                   </tr>
                   <tr>
                       <td colSpan="2" style={{
                           background: "rgba(128,208,119,0.75)",
                           textAlign: "center",
                           verticalAlign: "top",
                           padding: "20px 0"
                       }}>
                           15 Min Pause
                       </td>

                   </tr>
                   <tr style={{background:"#c9e3ef"}}>
                       <th>5. Stunde</th>
                       <td>12:00 - 12:45 Uhr</td>
                   </tr>
                   <tr>
                       <td colSpan="2" style={{
                           background: "rgba(128,208,119,0.75)",
                           textAlign: "center",
                           verticalAlign: "top",
                           padding: "20px 0"
                       }}>
                           Mittagessen 12:45 - 13:30 Uhr</td>
                   </tr>
                   <tr style={{background:"#c9e3ef"}}>
                       <th>6. Stunde</th>
                       <td>13:30 - 14:15 Uhr</td>
                   </tr>

                   <tr style={{background:"#c9e3ef"}}>
                      <th>7. Stunde</th>
                      <td>14:15 - 15:00 Uhr</td>
                  </tr>
                    <tr>
                     <td colSpan="2" style={{
                         background: "rgba(128,208,119,0.75)",
                         textAlign: "center",
                         verticalAlign: "top",
                         padding: "20px 0"
                     }}>
                         Snack 14:45 - 15:00 Uhr</td>
                 </tr>
                  <tr style={{background:"#c9e3ef"}}>
                     <th>8. Stunde</th>
                     <td>15:00 - 15:45 Uhr</td>
                 </tr>
                   <tr style={{background:"#c9e3ef"}}>
                       <th>Spätbetreuung</th>
                       <td>15:45 - 16:30 Uhr</td>
                   </tr>
               </table>
               </div>
           </section>

       </main>


    )

}
export default Info;